import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../stores/useUser.store';
import { Button } from '@/components/shadcn-ui/button';
import { Input } from '@/components/shadcn-ui/input';
import { Label } from '@/components/shadcn-ui/label';
import { generateAdminAuthUrl, generateAuthUrl } from '@/network/project.service';
import { appAxios } from '@/network/base/appAxios';
import { toast } from 'sonner';

const AdminAuthPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useUserStore();

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleClick = async type => {
    // const { data } = await generateAdminAuthUrl({
    //   type: type,
    //   grantType: 'email-password',
    //   clientId,
    //   clientSecret,
    //   redirectUrl,
    // });
    const response = await appAxios.post('/Auth/v1.0/admin-authurl', {
      type: type,
      grantType: 'email-password',
    });
    if (response.data.data.success && response.data.data.data?.authUrl) {
      window.location.href = response.data.data.data?.authUrl;
    } else {
      toast.error('Auth Url not received , please try again');
    }
  };

  return (
    <div className="dark min-h-screen bg-muted flex items-center justify-center px-4 py-12 w-full">
      <main className="w-full max-w-md">
        <section className="bg-card rounded-2xl shadow-lg p-8 md:p-10 border border-border transition-all">
          {/* Header */}
          <div className="text-center mb-10">
            <h1 className="text-4xl font-bold text-primary mb-3 tracking-tight">Zermit AI Admin</h1>
            <p className="text-muted-foreground text-sm">Admin Login to manage the system</p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col gap-4">
            <Button
              className="py-3 text-base font-medium shadow hover:shadow-md transition"
              onClick={() => handleClick('login')}
            >
              Sign In
            </Button>
          </div>

          {/* Divider */}
          <div className="mt-8 flex items-center gap-4">
            <div className="flex-1 h-px bg-border"></div>
            <span className="text-xs text-muted-foreground">Info</span>
            <div className="flex-1 h-px bg-border"></div>
          </div>

          {/* Footer */}
          <p className="mt-4 text-center text-sm text-muted-foreground">Use signin to continue</p>
        </section>
      </main>
    </div>
  );
};

export default AdminAuthPage;
